(function () {
  window.MF_DAILY_QUOTES = [
  {
    "text": "The secret of getting ahead is getting started.",
    "author": "Mark Twain"
  },
  {
    "text": "It always seems impossible until it is done.",
    "author": "Nelson Mandela"
  },
  {
    "text": "Well done is better than well said.",
    "author": "Benjamin Franklin"
  },
  {
    "text": "Energy and persistence conquer all things.",
    "author": "Benjamin Franklin"
  },
  {
    "text": "Action is the foundational key to all success.",
    "author": "Pablo Picasso"
  },
  {
    "text": "The future depends on what you do today.",
    "author": "Mahatma Gandhi"
  },
  {
    "text": "Learning never exhausts the mind.",
    "author": "Leonardo da Vinci"
  },
  {
    "text": "Genius is one percent inspiration and ninety-nine percent perspiration.",
    "author": "Thomas Edison"
  },
  {
    "text": "The expert in anything was once a beginner.",
    "author": "Helen Hayes"
  },
  {
    "text": "An investment in knowledge pays the best interest.",
    "author": "Benjamin Franklin"
  },
  {
    "text": "Knowledge is power.",
    "author": "Francis Bacon"
  },
  {
    "text": "The roots of education are bitter, but the fruit is sweet.",
    "author": "Aristotle"
  },
  {
    "text": "Education is the kindling of a flame, not the filling of a vessel.",
    "author": "Socrates"
  },
  {
    "text": "The only true wisdom is in knowing you know nothing.",
    "author": "Socrates"
  },
  {
    "text": "He who opens a school door, closes a prison.",
    "author": "Victor Hugo"
  },
  {
    "text": "The journey of a thousand miles begins with one step.",
    "author": "Lao Tzu"
  },
  {
    "text": "Do what you can, with what you have, where you are.",
    "author": "Theodore Roosevelt"
  },
  {
    "text": "Believe you can and you're halfway there.",
    "author": "Theodore Roosevelt"
  },
  {
    "text": "Act as if what you do makes a difference. It does.",
    "author": "William James"
  },
  {
    "text": "To improve is to change; to be perfect is to change often.",
    "author": "Winston Churchill"
  },
  {
    "text": "Success is stumbling from failure to failure with no loss of enthusiasm.",
    "author": "Winston Churchill"
  },
  {
    "text": "Continuous effort, not strength or intelligence, is the key to unlocking our potential.",
    "author": "Winston Churchill"
  },
  {
    "text": "The way to get started is to quit talking and begin doing.",
    "author": "Walt Disney"
  },
  {
    "text": "All our dreams can come true, if we have the courage to pursue them.",
    "author": "Walt Disney"
  },
  {
    "text": "The best way out is always through.",
    "author": "Robert Frost"
  },
  {
    "text": "In the middle of difficulty lies opportunity.",
    "author": "Albert Einstein"
  },
  {
    "text": "Imagination is more important than knowledge.",
    "author": "Albert Einstein"
  },
  {
    "text": "Life is like riding a bicycle. To keep your balance, you must keep moving.",
    "author": "Albert Einstein"
  },
  {
    "text": "I have no special talent. I am only passionately curious.",
    "author": "Albert Einstein"
  },
  {
    "text": "Once you stop learning, you start dying.",
    "author": "Albert Einstein"
  },
  {
    "text": "Quality is not an act, it is a habit.",
    "author": "Aristotle"
  },
  {
    "text": "We are what we repeatedly do.",
    "author": "Aristotle"
  },
  {
    "text": "Knowing yourself is the beginning of all wisdom.",
    "author": "Aristotle"
  },
  {
    "text": "Pleasure in the job puts perfection in the work.",
    "author": "Aristotle"
  },
  {
    "text": "It does not matter how slowly you go as long as you do not stop.",
    "author": "Confucius"
  },
  {
    "text": "Our greatest glory is not in never falling, but in rising every time we fall.",
    "author": "Confucius"
  },
  {
    "text": "Real knowledge is to know the extent of one's ignorance.",
    "author": "Confucius"
  },
  {
    "text": "Study the past if you would define the future.",
    "author": "Confucius"
  },
  {
    "text": "Wherever you go, go with all your heart.",
    "author": "Confucius"
  },
  {
    "text": "What we learn with pleasure we never forget.",
    "author": "Alfred Mercier"
  },
  {
    "text": "The beautiful thing about learning is that nobody can take it away from you.",
    "author": "B. B. King"
  },
  {
    "text": "Preparation is the key to success.",
    "author": "Alexander Graham Bell"
  },
  {
    "text": "Before anything else, preparation is the key to success.",
    "author": "Alexander Graham Bell"
  },
  {
    "text": "A person who never made a mistake never tried anything new.",
    "author": "Albert Einstein"
  },
  {
    "text": "Try not to become a person of success, but rather a person of value.",
    "author": "Albert Einstein"
  },
  {
    "text": "The mind is not a vessel to be filled, but a fire to be kindled.",
    "author": "Plutarch"
  },
  {
    "text": "No great thing is created suddenly.",
    "author": "Epictetus"
  },
  {
    "text": "First say to yourself what you would be; then do what you have to do.",
    "author": "Epictetus"
  },
  {
    "text": "If you want to improve, be content to be thought foolish and stupid.",
    "author": "Epictetus"
  },
  {
    "text": "Waste no more time arguing what a good person should be. Be one.",
    "author": "Marcus Aurelius"
  },
  {
    "text": "The impediment to action advances action.",
    "author": "Marcus Aurelius"
  },
  {
    "text": "You have power over your mind, not outside events.",
    "author": "Marcus Aurelius"
  },
  {
    "text": "Begin at once to live, and count each separate day as a separate life.",
    "author": "Seneca"
  },
  {
    "text": "Luck is what happens when preparation meets opportunity.",
    "author": "Seneca"
  },
  {
    "text": "Difficulties strengthen the mind, as labor does the body.",
    "author": "Seneca"
  },
  {
    "text": "No pressure, no diamonds.",
    "author": "Thomas Carlyle"
  },
  {
    "text": "Go as far as you can see; when you get there, you'll see further.",
    "author": "Thomas Carlyle"
  },
  {
    "text": "Nothing will work unless you do.",
    "author": "Maya Angelou"
  },
  {
    "text": "Do the best you can until you know better.",
    "author": "Maya Angelou"
  },
  {
    "text": "When you know better, do better.",
    "author": "Maya Angelou"
  },
  {
    "text": "Success is liking yourself, liking what you do, and liking how you do it.",
    "author": "Maya Angelou"
  },
  {
    "text": "If there is no struggle, there is no progress.",
    "author": "Frederick Douglass"
  },
  {
    "text": "Without a struggle, there can be no progress.",
    "author": "Frederick Douglass"
  },
  {
    "text": "I prayed for twenty years but received no answer until I prayed with my legs.",
    "author": "Frederick Douglass"
  },
  {
    "text": "You are your best thing.",
    "author": "Toni Morrison"
  },
  {
    "text": "Freeing yourself was one thing; claiming ownership of that freed self was another.",
    "author": "Toni Morrison"
  },
  {
    "text": "The function of freedom is to free someone else.",
    "author": "Toni Morrison"
  },
  {
    "text": "I am deliberate and afraid of nothing.",
    "author": "Audre Lorde"
  },
  {
    "text": "When I dare to be powerful, to use my strength, then fear becomes less important.",
    "author": "Audre Lorde"
  },
  {
    "text": "The most common way people give up their power is by thinking they don't have any.",
    "author": "Alice Walker"
  },
  {
    "text": "Hard times require furious dancing.",
    "author": "Alice Walker"
  },
  {
    "text": "No person is your friend who demands your silence.",
    "author": "Alice Walker"
  },
  {
    "text": "The question isn't who's going to let me; it's who's going to stop me.",
    "author": "Ayn Rand"
  },
  {
    "text": "The only limit to our realization of tomorrow is our doubts of today.",
    "author": "Franklin D. Roosevelt"
  },
  {
    "text": "Happiness lies in the joy of achievement.",
    "author": "Franklin D. Roosevelt"
  },
  {
    "text": "The only thing we have to fear is fear itself.",
    "author": "Franklin D. Roosevelt"
  },
  {
    "text": "You must do the thing you think you cannot do.",
    "author": "Eleanor Roosevelt"
  },
  {
    "text": "The future belongs to those who believe in the beauty of their dreams.",
    "author": "Eleanor Roosevelt"
  },
  {
    "text": "No one can make you feel inferior without your consent.",
    "author": "Eleanor Roosevelt"
  },
  {
    "text": "It takes as much energy to wish as it does to plan.",
    "author": "Eleanor Roosevelt"
  },
  {
    "text": "Do one thing every day that scares you.",
    "author": "Eleanor Roosevelt"
  },
  {
    "text": "The most effective way to do it, is to do it.",
    "author": "Amelia Earhart"
  },
  {
    "text": "Courage is the price that life exacts for granting peace.",
    "author": "Amelia Earhart"
  },
  {
    "text": "Never interrupt someone doing what you said couldn't be done.",
    "author": "Amelia Earhart"
  },
  {
    "text": "I dwell in possibility.",
    "author": "Emily Dickinson"
  },
  {
    "text": "Forever is composed of nows.",
    "author": "Emily Dickinson"
  },
  {
    "text": "Hope is the thing with feathers.",
    "author": "Emily Dickinson"
  },
  {
    "text": "That it will never come again is what makes life so sweet.",
    "author": "Emily Dickinson"
  },
  {
    "text": "What you do speaks so loudly that I cannot hear what you say.",
    "author": "Ralph Waldo Emerson"
  },
  {
    "text": "Once you make a decision, the universe conspires to make it happen.",
    "author": "Ralph Waldo Emerson"
  },
  {
    "text": "Nothing great was ever achieved without enthusiasm.",
    "author": "Ralph Waldo Emerson"
  },
  {
    "text": "Always do what you are afraid to do.",
    "author": "Ralph Waldo Emerson"
  },
  {
    "text": "The only way to have a friend is to be one.",
    "author": "Ralph Waldo Emerson"
  },
  {
    "text": "Go confidently in the direction of your dreams.",
    "author": "Henry David Thoreau"
  },
  {
    "text": "What you get by achieving your goals is not as important as what you become.",
    "author": "Henry David Thoreau"
  },
  {
    "text": "Success usually comes to those who are too busy to be looking for it.",
    "author": "Henry David Thoreau"
  },
  {
    "text": "Not all those who wander are lost.",
    "author": "J. R. R. Tolkien"
  },
  {
    "text": "Courage is found in unlikely places.",
    "author": "J. R. R. Tolkien"
  },
  {
    "text": "Little by little, one travels far.",
    "author": "J. R. R. Tolkien"
  },
  {
    "text": "It is our choices that show what we truly are.",
    "author": "J. K. Rowling"
  },
  {
    "text": "Rock bottom became the solid foundation on which I rebuilt my life.",
    "author": "J. K. Rowling"
  },
  {
    "text": "We do not need magic to transform our world.",
    "author": "J. K. Rowling"
  },
  {
    "text": "You miss 100 percent of the shots you don't take.",
    "author": "Wayne Gretzky"
  },
  {
    "text": "A good hockey player plays where the puck is.",
    "author": "Wayne Gretzky"
  },
  {
    "text": "I've failed over and over and over again in my life. And that is why I succeed.",
    "author": "Michael Jordan"
  },
  {
    "text": "Some people want it to happen, some wish it would happen, others make it happen.",
    "author": "Michael Jordan"
  },
  {
    "text": "You must expect great things of yourself before you can do them.",
    "author": "Michael Jordan"
  },
  {
    "text": "Don't count the days, make the days count.",
    "author": "Muhammad Ali"
  },
  {
    "text": "He who is not courageous enough to take risks will accomplish nothing.",
    "author": "Muhammad Ali"
  },
  {
    "text": "The man who has no imagination has no wings.",
    "author": "Muhammad Ali"
  },
  {
    "text": "If my mind can conceive it, then I can achieve it.",
    "author": "Muhammad Ali"
  },
  {
    "text": "Float like a butterfly, sting like a bee.",
    "author": "Muhammad Ali"
  },
  {
    "text": "Champions keep playing until they get it right.",
    "author": "Billie Jean King"
  },
  {
    "text": "Pressure is a privilege.",
    "author": "Billie Jean King"
  },
  {
    "text": "I think self-awareness is probably the most important thing.",
    "author": "Billie Jean King"
  },
  {
    "text": "The difference between the impossible and the possible lies in determination.",
    "author": "Tommy Lasorda"
  },
  {
    "text": "The harder the conflict, the greater the triumph.",
    "author": "George Washington"
  },
  {
    "text": "Perseverance and spirit have done wonders in all ages.",
    "author": "George Washington"
  },
  {
    "text": "Give me six hours to chop down a tree and I will spend four sharpening the axe.",
    "author": "Abraham Lincoln"
  },
  {
    "text": "I am a slow walker, but I never walk back.",
    "author": "Abraham Lincoln"
  },
  {
    "text": "The best way to predict your future is to create it.",
    "author": "Abraham Lincoln"
  },
  {
    "text": "Whatever you are, be a good one.",
    "author": "Abraham Lincoln"
  },
  {
    "text": "I walk slowly, but I never walk backward.",
    "author": "Abraham Lincoln"
  },
  {
    "text": "Every strike brings me closer to the next home run.",
    "author": "Babe Ruth"
  },
  {
    "text": "It is hard to beat a person who never gives up.",
    "author": "Babe Ruth"
  },
  {
    "text": "Never let the fear of striking out keep you from playing the game.",
    "author": "Babe Ruth"
  },
  {
    "text": "Do not wait to strike till the iron is hot; make it hot by striking.",
    "author": "William Butler Yeats"
  },
  {
    "text": "Education is not the filling of a pail, but the lighting of a fire.",
    "author": "William Butler Yeats"
  },
  {
    "text": "There are no strangers here; only friends you haven't yet met.",
    "author": "William Butler Yeats"
  },
  {
    "text": "Think like a wise man but communicate in the language of the people.",
    "author": "William Butler Yeats"
  },
  {
    "text": "The important thing is not to stop questioning.",
    "author": "Albert Einstein"
  },
  {
    "text": "Stay hungry, stay foolish.",
    "author": "Steve Jobs"
  },
  {
    "text": "Innovation distinguishes between a leader and a follower.",
    "author": "Steve Jobs"
  },
  {
    "text": "The people who are crazy enough to think they can change the world are the ones who do.",
    "author": "Steve Jobs"
  },
  {
    "text": "Your time is limited, so don't waste it living someone else's life.",
    "author": "Steve Jobs"
  },
  {
    "text": "The only way to do great work is to love what you do.",
    "author": "Steve Jobs"
  },
  {
    "text": "I never dreamed about success. I worked for it.",
    "author": "Estee Lauder"
  },
  {
    "text": "When you stop talking, you've lost your customer.",
    "author": "Estee Lauder"
  },
  {
    "text": "I didn't get there by wishing for it, but by working for it.",
    "author": "Estee Lauder"
  },
  {
    "text": "The most difficult thing is the decision to act, the rest is merely tenacity.",
    "author": "Amelia Earhart"
  },
  {
    "text": "If you can dream it, you can do it.",
    "author": "Walt Disney"
  },
  {
    "text": "Whether you think you can or think you can't, you're right.",
    "author": "Henry Ford"
  },
  {
    "text": "Failure is simply the opportunity to begin again, this time more intelligently.",
    "author": "Henry Ford"
  },
  {
    "text": "Obstacles are those frightful things you see when you take your eyes off your goal.",
    "author": "Henry Ford"
  },
  {
    "text": "Nothing is particularly hard if you divide it into small jobs.",
    "author": "Henry Ford"
  },
  {
    "text": "The only real mistake is the one from which we learn nothing.",
    "author": "Henry Ford"
  },
  {
    "text": "The best revenge is massive success.",
    "author": "Frank Sinatra"
  },
  {
    "text": "You may be disappointed if you fail, but you are doomed if you don't try.",
    "author": "Beverly Sills"
  },
  {
    "text": "There are no shortcuts to any place worth going.",
    "author": "Beverly Sills"
  },
  {
    "text": "A goal without a plan is just a wish.",
    "author": "Antoine de Saint-Exupery"
  },
  {
    "text": "Tell me and I forget. Teach me and I remember. Involve me and I learn.",
    "author": "Benjamin Franklin"
  },
  {
    "text": "Lost time is never found again.",
    "author": "Benjamin Franklin"
  },
  {
    "text": "By failing to prepare, you are preparing to fail.",
    "author": "Benjamin Franklin"
  },
  {
    "text": "Diligence is the mother of good luck.",
    "author": "Benjamin Franklin"
  },
  {
    "text": "Either write something worth reading or do something worth writing.",
    "author": "Benjamin Franklin"
  },
  {
    "text": "Without continual growth and progress, such words as improvement, achievement, and success have no meaning.",
    "author": "Benjamin Franklin"
  },
  {
    "text": "Coming together is a beginning; keeping together is progress; working together is success.",
    "author": "Henry Ford"
  },
  {
    "text": "My great hope is to laugh as much as I cry; to get my work done and try to love somebody and have the courage to accept the love in return.",
    "author": "Maya Angelou"
  },
  {
    "text": "There is nothing like a dream to create the future.",
    "author": "Victor Hugo"
  },
  {
    "text": "Enthusiasm is the mother of effort, and without it nothing great was ever achieved.",
    "author": "Ralph Waldo Emerson"
  },
  {
    "text": "Times and conditions change so rapidly that we must keep our aim constantly focused on the future.",
    "author": "Walt Disney"
  },
  {
    "text": "It is only through labor and painful effort, by grim energy and resolute courage, that we move on to better things.",
    "author": "Theodore Roosevelt"
  },
  {
    "text": "To make no mistakes is not in the power of man; but from their errors and mistakes the wise and good learn wisdom for the future.",
    "author": "Plutarch"
  },
  {
    "text": "I hope the millions of people I've touched have the optimism and desire to share their goals and hard work and persevere with a positive attitude.",
    "author": "Michael Jordan"
  },
  {
    "text": "The game has its ups and downs, but you can never lose focus of your individual goals and you can't let yourself be beat because of lack of effort.",
    "author": "Michael Jordan"
  },
  {
    "text": "Our goals can only be reached through a vehicle of a plan, in which we must fervently believe, and upon which we must vigorously act. There is no other route to success.",
    "author": "Pablo Picasso"
  },
  {
    "text": "Silence is a source of great strength.",
    "author": "Lao Tzu"
  },
  {
    "text": "Tread softly because you tread on my dreams.",
    "author": "William Butler Yeats"
  },
  {
    "text": "A loving heart is the beginning of all knowledge.",
    "author": "Thomas Carlyle"
  },
  {
    "text": "Money won't create success, the freedom to make it will.",
    "author": "Nelson Mandela"
  },
  {
    "text": "The true sign of intelligence is not knowledge but imagination.",
    "author": "Albert Einstein"
  },
  {
    "text": "Liberty, when it begins to take root, is a plant of rapid growth.",
    "author": "George Washington"
  },
  {
    "text": "One has to grow up with good talk in order to form the habit of it.",
    "author": "Helen Hayes"
  },
  {
    "text": "Silence at the proper season is wisdom, and better than any speech.",
    "author": "Plutarch"
  },
  {
    "text": "You can't depend on your eyes when your imagination is out of focus.",
    "author": "Mark Twain"
  },
  {
    "text": "I've always believed that if you put in the work, the results will come.",
    "author": "Michael Jordan"
  },
  {
    "text": "Happiness lies in the joy of achievement and the thrill of creative effort.",
    "author": "Franklin D. Roosevelt"
  },
  {
    "text": "Try not to become a man of success, but rather try to become a man of value.",
    "author": "Albert Einstein"
  },
  {
    "text": "Believe that life is worth living and your belief will help create the fact.",
    "author": "William James"
  },
  {
    "text": "The ladder of success is best climbed by stepping on the rungs of opportunity.",
    "author": "Ayn Rand"
  },
  {
    "text": "Education is what remains after one has forgotten what one has learned in school.",
    "author": "Albert Einstein"
  },
  {
    "text": "Why does the eye see a thing more clearly in dreams than the imagination when awake?",
    "author": "Leonardo da Vinci"
  },
  {
    "text": "Satisfaction lies in the effort, not in the attainment, full effort is full victory.",
    "author": "Mahatma Gandhi"
  },
  {
    "text": "Old age is like everything else. To make a success of it, you've got to start young.",
    "author": "Theodore Roosevelt"
  },
  {
    "text": "The great law of culture is: Let each becomeall that he was created capable of being.",
    "author": "Thomas Carlyle"
  },
  {
    "text": "Success is not final, failure is not fatal: it is the courage to continue that counts.",
    "author": "Winston Churchill"
  },
  {
    "text": "Great thoughts speak only to the thoughtful mind, but great actions speak to all mankind.",
    "author": "Theodore Roosevelt"
  },
  {
    "text": "The old cathedrals are good, but the great blue dome that hangs over everything is better.",
    "author": "Thomas Carlyle"
  },
  {
    "text": "You have to learn the rules of the game. And then you have to play better than anyone else.",
    "author": "Albert Einstein"
  },
  {
    "text": "Wisdom, compassion, and courage are the three universally recognized moral qualities of men.",
    "author": "Confucius"
  },
  {
    "text": "He who learns but does not think, is lost! He who thinks but does not learn is in great danger.",
    "author": "Confucius"
  },
  {
    "text": "Being deeply loved by someone gives you strength, while loving someone deeply gives you courage.",
    "author": "Lao Tzu"
  },
  {
    "text": "When it is obvious that the goals cannot be reached, don't adjust the goals, adjust the action steps.",
    "author": "Confucius"
  },
  {
    "text": "I don't need a friend who changes when I change and who nods when I nod; my shadow does that much better.",
    "author": "Plutarch"
  },
  {
    "text": "People grow through experience if they meet life honestly and courageously. This is how character is built.",
    "author": "Eleanor Roosevelt"
  },
  {
    "text": "To be yourself in a world that is constantly trying to make you something else is the greatest accomplishment.",
    "author": "Ralph Waldo Emerson"
  },
  {
    "text": "You will never do anything in this world without courage. It is the greatest quality of the mind next to honor.",
    "author": "Aristotle"
  },
  {
    "text": "Disneyland will never be completed. It will continue to grow as long as there is imagination left in the world.",
    "author": "Walt Disney"
  },
  {
    "text": "There is no such thing as a perfect basketball player, and I don't believe there is only one greatest player either.",
    "author": "Michael Jordan"
  },
  {
    "text": "It isn't enough to talk about peace. One must believe in it. And it isn't enough to believe in it. One must work at it.",
    "author": "Eleanor Roosevelt"
  },
  {
    "text": "It is our attitude at the beginning of a difficult task which, more than anything else, will affect its successful outcome.",
    "author": "William James"
  },
  {
    "text": "You can design and create, and build the most wonderful place in the world. But it takes people to make the dream a reality.",
    "author": "Walt Disney"
  },
  {
    "text": "But I, being poor, have only my dreams; I have spread my dreams under your feet; Tread softly because you tread on my dreams.",
    "author": "William Butler Yeats"
  },
  {
    "text": "The brain is a wonderful organ; it starts working the moment you get up in the morning and does not stop until you get into the office.",
    "author": "Robert Frost"
  },
  {
    "text": "Do the difficult things while they are easy and do the great things while they are small. A journey of a thousand miles must begin with a single step.",
    "author": "Lao Tzu"
  },
  {
    "text": "Anyone who stops learning is old, whether at twenty or eighty. Anyone who keeps learning stays young. The greatest thing in life is to keep your mind young.",
    "author": "Henry Ford"
  },
  {
    "text": "I learned that courage was not the absence of fear, but the triumph over it. The brave man is not he who does not feel afraid, but he who conquers that fear.",
    "author": "Nelson Mandela"
  },
  {
    "text": "We gain strength, and courage, and confidence by each experience in which we really stop to look fear in the face... we must do that which we think we cannot.",
    "author": "Eleanor Roosevelt"
  },
  {
    "text": "He, who every morning plans the transactions of the day, and follows that plan, carries a thread that will guide him through a labyrinth of the most busy life.",
    "author": "Victor Hugo"
  },
  {
    "text": "By three methods we may learn wisdom: First, by reflection, which is noblest; Second, by imitation, which is easiest; and third by experience, which is the bitterest.",
    "author": "Confucius"
  },
  {
    "text": "Nothing stops the man who desires to achieve. Every obstacle is simply a course to develop his achievement muscle. It's a strengthening of his powers of accomplishment.",
    "author": "Thomas Carlyle"
  },
  {
    "text": "If one advances confidently in the direction of his dreams, and endeavors to live the life which he has imagined, he will meet with a success unexpected in common hours.",
    "author": "Henry David Thoreau"
  },
  {
    "text": "Everybody starts at the top, and then has the problem of staying there. Lasting accomplishment, however, is still achieved through a long, slow climb and self-discipline.",
    "author": "Helen Hayes"
  },
  {
    "text": "Belief creates the actual fact.",
    "author": "William James"
  },
  {
    "text": "Things do not change; we change.",
    "author": "Henry David Thoreau"
  },
  {
    "text": "To be great is to be misunderstood.",
    "author": "Ralph Waldo Emerson"
  },
  {
    "text": "For knowledge, too, is itself power.",
    "author": "Francis Bacon"
  },
  {
    "text": "Perseverance, secret of all triumphs.",
    "author": "Victor Hugo"
  },
  {
    "text": "Try to be a rainbow in someone's cloud.",
    "author": "Maya Angelou"
  },
  {
    "text": "Every noble work is at first impossible.",
    "author": "Thomas Carlyle"
  },
  {
    "text": "Love is the greatest refreshment in life.",
    "author": "Pablo Picasso"
  },
  {
    "text": "Character is simply habit long continued.",
    "author": "Plutarch"
  },
  {
    "text": "The only source of knowledge is experience.",
    "author": "Albert Einstein"
  },
  {
    "text": "Silence is the sleep that nourishes wisdom.",
    "author": "Francis Bacon"
  },
  {
    "text": "Never read any book that is not a year old.",
    "author": "Ralph Waldo Emerson"
  },
  {
    "text": "Begin to be now what you will be hereafter.",
    "author": "William James"
  },
  {
    "text": "Happiness is not a goal; it is a by-product.",
    "author": "Eleanor Roosevelt"
  },
  {
    "text": "Nine-tenths of wisdom is being wise in time.",
    "author": "Theodore Roosevelt"
  },
  {
    "text": "It is better to be alone than in bad company.",
    "author": "George Washington"
  },
  {
    "text": "This world is but a canvas to our imagination.",
    "author": "Henry David Thoreau"
  },
  {
    "text": "It is better to offer no excuse than a bad one.",
    "author": "George Washington"
  },
  {
    "text": "A man's worth is no greater than his ambitions.",
    "author": "Marcus Aurelius"
  },
  {
    "text": "Character is that which can do without success.",
    "author": "Ralph Waldo Emerson"
  },
  {
    "text": "All rising to great place is by a winding stair.",
    "author": "Francis Bacon"
  },
  {
    "text": "Money is like muck, not good except it be spread.",
    "author": "Francis Bacon"
  },
  {
    "text": "Nothing strengthens authority so much as silence.",
    "author": "Leonardo da Vinci"
  },
  {
    "text": "Name the greatest of all the inventors: Accident.",
    "author": "Mark Twain"
  },
  {
    "text": "Write with the learned, pronounce with the vulgar.",
    "author": "Benjamin Franklin"
  },
  {
    "text": "You cannot open a book without learning something.",
    "author": "Confucius"
  },
  {
    "text": "Better a diamond with a flaw than a pebble without.",
    "author": "Confucius"
  },
  {
    "text": "Good habits formed at youth make all the difference.",
    "author": "Aristotle"
  },
  {
    "text": "Where there is shouting, there is no true knowledge.",
    "author": "Leonardo da Vinci"
  },
  {
    "text": "You must be the change you wish to see in the world.",
    "author": "Mahatma Gandhi"
  },
  {
    "text": "Nothing so needs reforming as other people's habits.",
    "author": "Mark Twain"
  },
  {
    "text": "The hour which gives us life begins to take it away.",
    "author": "Seneca"
  },
  {
    "text": "If you want a quality, act as if you already had it.",
    "author": "William James"
  },
  {
    "text": "With the new day comes new strength and new thoughts.",
    "author": "Eleanor Roosevelt"
  },
  {
    "text": "All our knowledge has its origins in our perceptions.",
    "author": "Leonardo da Vinci"
  },
  {
    "text": "To find fault is easy; to do better may be difficult.",
    "author": "Plutarch"
  },
  {
    "text": "Strive not to be a success, but rather to be of value.",
    "author": "Albert Einstein"
  },
  {
    "text": "Who questions much, shall learn much, and retain much.",
    "author": "Francis Bacon"
  },
  {
    "text": "We are always getting ready to live, but never living.",
    "author": "Ralph Waldo Emerson"
  },
  {
    "text": "Things don't have to change the world to be important.",
    "author": "Steve Jobs"
  },
  {
    "text": "The empires of the future are the empires of the mind.",
    "author": "Winston Churchill"
  },
  {
    "text": "It is better to light a candle than curse the darkness.",
    "author": "Eleanor Roosevelt"
  },
  {
    "text": "Success is counted sweetest By those who ne'er succeed.",
    "author": "Emily Dickinson"
  },
  {
    "text": "God hangs the greatest weights upon the smallest wires.",
    "author": "Francis Bacon"
  },
  {
    "text": "True knowledge exists in knowing that you know nothing.",
    "author": "Socrates"
  },
  {
    "text": "It is far better to be alone, than to be in bad company.",
    "author": "George Washington"
  },
  {
    "text": "I am the greatest, I said that even before I knew I was.",
    "author": "Muhammad Ali"
  },
  {
    "text": "To see what is right and not to do it is want of courage.",
    "author": "Confucius"
  },
  {
    "text": "Not until we are lost do we begin to understand ourselves.",
    "author": "Henry David Thoreau"
  },
  {
    "text": "Colors, like features, follow the changes of the emotions.",
    "author": "Pablo Picasso"
  },
  {
    "text": "If a man's wit be wandering, let him study the mathematics.",
    "author": "Francis Bacon"
  },
  {
    "text": "Knowing others is wisdom, knowing yourself is Enlightenment.",
    "author": "Lao Tzu"
  },
  {
    "text": "My only fault is that I don't realize how great I really am.",
    "author": "Muhammad Ali"
  },
  {
    "text": "He who boasts of his ancestry praises the merits of another.",
    "author": "Seneca"
  },
  {
    "text": "It's the job that's never started as takes longest to finish.",
    "author": "J. R. R. Tolkien"
  },
  {
    "text": "Painting is silent poetry, and poetry is painting that speaks.",
    "author": "Plutarch"
  },
  {
    "text": "It is only the wisest and the very stupidest who cannot change.",
    "author": "Confucius"
  },
  {
    "text": "Mastering others is strength. Mastering yourself is true power.",
    "author": "Lao Tzu"
  },
  {
    "text": "Courageous people do not fear forgiving, for the sake of peace.",
    "author": "Nelson Mandela"
  },
  {
    "text": "The time for action is now. It's never too late to do something.",
    "author": "Antoine de Saint-Exupery"
  },
  {
    "text": "To love is so startling it leaves little time for anything else.",
    "author": "Emily Dickinson"
  },
  {
    "text": "The price of anything is the amount of life you exchange for it.",
    "author": "Henry David Thoreau"
  },
  {
    "text": "Loss is nothing else but change, and change is Nature's delight.",
    "author": "Marcus Aurelius"
  },
  {
    "text": "The human foot is a masterpiece of engineering and a work of art.",
    "author": "Leonardo da Vinci"
  },
  {
    "text": "You can have no dominion greater or less than that over yourself.",
    "author": "Leonardo da Vinci"
  },
  {
    "text": "The greatest of faults, I should say, is to be conscious of none.",
    "author": "Thomas Carlyle"
  },
  {
    "text": "We are all born ignorant, but one must work hard to remain stupid.",
    "author": "Benjamin Franklin"
  },
  {
    "text": "The best thing about the future is that it comes one day at a time.",
    "author": "Abraham Lincoln"
  },
  {
    "text": "The purpose of art is washing the dust of daily life off our souls.",
    "author": "Pablo Picasso"
  },
  {
    "text": "Better do a good deed near at home than go far away to burn incense.",
    "author": "Amelia Earhart"
  },
  {
    "text": "The worst form of inequality is to try to make unequal things equal.",
    "author": "Aristotle"
  },
  {
    "text": "Dogs are better than human beings because they know but do not tell.",
    "author": "Emily Dickinson"
  },
  {
    "text": "Behavior is what a man does, not what he thinks, feels, or believes.",
    "author": "Emily Dickinson"
  },
  {
    "text": "Talent wins games, but teamwork and intelligence wins championships.",
    "author": "Michael Jordan"
  },
  {
    "text": "All life is an experiment. The more experiments you make the better.",
    "author": "Ralph Waldo Emerson"
  },
  {
    "text": "Shallow men believe in luck. Strong men believe in cause and effect.",
    "author": "Ralph Waldo Emerson"
  },
  {
    "text": "If you do not change direction, you may end up where you are heading.",
    "author": "Lao Tzu"
  },
  {
    "text": "The very spring and root of honesty and virtue lie in good education.",
    "author": "Plutarch"
  },
  {
    "text": "It is a good thing for an uneducated man to read books of quotations.",
    "author": "Winston Churchill"
  },
  {
    "text": "Look deep into nature, and then you will understand everything better.",
    "author": "Albert Einstein"
  },
  {
    "text": "Natural abilities are like natural plants, that need pruning by study.",
    "author": "Francis Bacon"
  },
  {
    "text": "The best way to cheer yourself up is to try to cheer somebody else up.",
    "author": "Mark Twain"
  },
  {
    "text": "Every new opinion, at its starting, is precisely in a minority of one.",
    "author": "Thomas Carlyle"
  },
  {
    "text": "Peace cannot be kept by force; it can only be achieved by understanding.",
    "author": "Albert Einstein"
  },
  {
    "text": "Wealth consists not in having great possessions, but in having few wants.",
    "author": "Epictetus"
  },
  {
    "text": "My mother had a great deal of trouble with me, but I think she enjoyed it.",
    "author": "Mark Twain"
  },
  {
    "text": "We are what we repeatedly do. Excellence, then, is not an act, but a habit.",
    "author": "Aristotle"
  },
  {
    "text": "The greatness of a nation can be judged by the way its animals are treated.",
    "author": "Mahatma Gandhi"
  },
  {
    "text": "In three words I can sum up everything I've learned about life: it goes on.",
    "author": "Robert Frost"
  },
  {
    "text": "The soul should always stand ajar, ready to welcome the ecstatic experience.",
    "author": "Emily Dickinson"
  },
  {
    "text": "You're dead if you aim only for kids. Adults are only kids grown up, anyway.",
    "author": "Walt Disney"
  },
  {
    "text": "A jury consists of twelve persons chosen to decide who has the better lawyer.",
    "author": "Robert Frost"
  },
  {
    "text": "Design is not just what it looks like and feels like. Design is how it works.",
    "author": "Steve Jobs"
  },
  {
    "text": "Intelligence is the wife, imagination is the mistress, memory is the servant.",
    "author": "Victor Hugo"
  },
  {
    "text": "Genius…means little more than the faculty of perceiving in an unhabitual way.",
    "author": "William James"
  },
  {
    "text": "Success consists of going from failure to failure without loss of enthusiasm.",
    "author": "Winston Churchill"
  },
  {
    "text": "He who is not courageous enough to take risks will accomplish nothing in life.",
    "author": "Muhammad Ali"
  },
  {
    "text": "There are good and bad times, but our mood changes more often than our fortune.",
    "author": "Thomas Carlyle"
  },
  {
    "text": "No person is your friend who demands your silence, or denies your right to grow.",
    "author": "Alice Walker"
  },
  {
    "text": "The woman who can create her own job is the woman who will win fame and fortune.",
    "author": "Amelia Earhart"
  },
  {
    "text": "A word is dead When it is said, Some say. I say it just Begins to live That day.",
    "author": "Emily Dickinson"
  },
  {
    "text": "A man is wise with the wisdom of his time only, and ignorant with its ignorance.",
    "author": "Henry David Thoreau"
  },
  {
    "text": "It's just a job. Grass grows, birds fly, waves pound the sand. I beat people up.",
    "author": "Muhammad Ali"
  },
  {
    "text": "It is part of a good man to do great and noble deeds, though he risk everything.",
    "author": "Plutarch"
  },
  {
    "text": "Poetry is when an emotion has found its thought and the thought has found words.",
    "author": "Robert Frost"
  },
  {
    "text": "Strength does not come from physical capacity. It comes from an indomitable will.",
    "author": "Mahatma Gandhi"
  },
  {
    "text": "I can accept failure, everyone fails at something. But I can't accept not trying.",
    "author": "Michael Jordan"
  },
  {
    "text": "I am always doing that which I cannot do, in order that I may learn how to do it.",
    "author": "Pablo Picasso"
  },
  {
    "text": "Every child is an artist. The problem is how to remain an artist once we grow up.",
    "author": "Pablo Picasso"
  },
  {
    "text": "To know, is to know that you know nothing. That is the meaning of true knowledge.",
    "author": "Socrates"
  },
  {
    "text": "The greatest way to live with honor in this world is to be what we pretend to be.",
    "author": "Socrates"
  },
  {
    "text": "All children are artists. The problem is how to remain an artist once he grows up.",
    "author": "Pablo Picasso"
  },
  {
    "text": "The aim of a college education is to teach you to know a good man when you see one.",
    "author": "William James"
  },
  {
    "text": "Great minds discuss ideas; average minds discuss events; small minds discuss people.",
    "author": "Eleanor Roosevelt"
  },
  {
    "text": "After climbing a great hill, one only finds that there are many more hills to climb.",
    "author": "Nelson Mandela"
  },
  {
    "text": "If you don't like something, change it. If you can't change it, change your attitude.",
    "author": "Maya Angelou"
  },
  {
    "text": "Even a mistake may turn out to be the one thing necessary to a worthwhile achievement.",
    "author": "Henry Ford"
  },
  {
    "text": "Most of the change we think we see in life Is due to truths being in and out of favor.",
    "author": "Robert Frost"
  },
  {
    "text": "When you believe in a thing, believe in it all the way, implicitly and unquestionable.",
    "author": "Walt Disney"
  },
  {
    "text": "Think where man's glory most begins and ends, and say my glory was I had such friends.",
    "author": "William Butler Yeats"
  },
  {
    "text": "A creative man is motivated by the desire to achieve, not by the desire to beat others.",
    "author": "Ayn Rand"
  },
  {
    "text": "Where the telescope ends, the microscope begins. Which of the two has the grander view?",
    "author": "Victor Hugo"
  },
  {
    "text": "I only hope that we don't lose sight of one thing - that it was all started by a mouse.",
    "author": "Walt Disney"
  },
  {
    "text": "We have to do with the past only as we can make it useful to the present and the future.",
    "author": "Frederick Douglass"
  },
  {
    "text": "True friendship can afford true knowledge. It does not depend on darkness and ignorance.",
    "author": "Henry David Thoreau"
  },
  {
    "text": "A poem begins as a lump in the throat, a sense of wrong, a homesickness, a lovesickness.",
    "author": "Robert Frost"
  },
  {
    "text": "My most brilliant achievement was my ability to be able to persuade my wife to marry me.",
    "author": "Winston Churchill"
  },
  {
    "text": "Most people spend more time and energy going around problems than in trying to solve them.",
    "author": "Henry Ford"
  },
  {
    "text": "Change your opinions, keep to your principles; change your leaves, keep intact your roots.",
    "author": "Victor Hugo"
  },
  {
    "text": "There is no more miserable human being than one in whom nothing is habitual but indecision.",
    "author": "William James"
  },
  {
    "text": "Thinking is the hardest work there is, which is probably the reason why so few engage in it.",
    "author": "Henry Ford"
  },
  {
    "text": "It's lack of faith that makes people afraid of meeting challenges, and I believed in myself.",
    "author": "Muhammad Ali"
  },
  {
    "text": "Happiness is that state of consciousness which proceeds from the achievement of one's values.",
    "author": "Ayn Rand"
  },
  {
    "text": "You have power over your mind - not outside events. Realize this, and you will find strength.",
    "author": "Marcus Aurelius"
  },
  {
    "text": "Take, if you must, this little bag of dreams, Unloose the cord, and they will wrap you round.",
    "author": "William Butler Yeats"
  },
  {
    "text": "You have been chosen, and you must therefore use such strength and heart and wits as you have.",
    "author": "J. R. R. Tolkien"
  },
  {
    "text": "Yes, Mother. I can see you are flawed. You have not hidden it. That is your greatest gift to me.",
    "author": "Alice Walker"
  },
  {
    "text": "They spell it Vinci and pronounce it Vinchy; foreigners always spell better than they pronounce.",
    "author": "Mark Twain"
  },
  {
    "text": "In soloing - as in other activities - it is far easier to start something than it is to finish it.",
    "author": "Amelia Earhart"
  },
  {
    "text": "Far and away the best prize that life has to offer is the chance to work hard at work worth doing.",
    "author": "Theodore Roosevelt"
  },
  {
    "text": "The things I want to know are in books; my best friend is the man who'll get me a book I ain't read.",
    "author": "Abraham Lincoln"
  },
  {
    "text": "People might not get all they work for in this world, but they must certainly work for all they get.",
    "author": "Frederick Douglass"
  },
  {
    "text": "What you get by achieving your goals is not as important as what you become by achieving your goals.",
    "author": "Henry David Thoreau"
  },
  {
    "text": "I cannot forecast to you the action of Russia. It is a riddle wrapped in a mystery inside an enigma.",
    "author": "Winston Churchill"
  },
  {
    "text": "Courage is what it takes to stand up and speak; courage is also what it takes to sit down and listen.",
    "author": "Winston Churchill"
  },
  {
    "text": "Have convictions. Be friendly. Stick to your beliefs as they stick to theirs. Work as hard as they do.",
    "author": "Eleanor Roosevelt"
  },
  {
    "text": "There is no Frigate like a Book To take us Lands away Nor any Coursers like a Page Of prancing Poetry.",
    "author": "Emily Dickinson"
  },
  {
    "text": "Nothing is in reality either pleasant or unpleasant by nature; but all things become so through habit.",
    "author": "Epictetus"
  },
  {
    "text": "By working faithfully eight hours a day you may eventually get to be boss and work twelve hours a day.",
    "author": "Robert Frost"
  },
  {
    "text": "Everyone here has the sense that right now is one of those moments when we are influencing the future.",
    "author": "Steve Jobs"
  },
  {
    "text": "Prejudice is a burden that confuses the past, threatens the future and renders the present inaccessible.",
    "author": "Maya Angelou"
  },
  {
    "text": "The machine does not isolate man from the great problems of nature but plunges him more deeply into them.",
    "author": "Antoine de Saint-Exupery"
  },
  {
    "text": "America is false to the past, false to the present, and solemnly binds herself to be false to the future.",
    "author": "Frederick Douglass"
  }
];
})();

